import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import DashboardConstants from '../DashboardConstants';
import moveHouse from './hikkoshi.svg';
import './Dashboard.scss';

const MoveAddressTile = (props) => {
  const { customerInfo } = props;
  if (!customerInfo.requestInProgress && customerInfo.connected) {
    return (
      <div id="move-address-tile" className="account-action-tile">
        <img
          src={moveHouse}
          alt="Move Address"
        />
        <div className="account-action-tile-title">
          Moving house?
        </div>
        <div className="account-action-tile-text">
          Great news! You can take your broadband with you. Just let us know when and where
          you&#39;re moving to and we&#39;ll sort out the Skinny connection at your new place.
        </div>
        <Button id="move-address-button" onClick={() => browserHistory.push('/move')}>
          {DashboardConstants.MOVE_ADDRESS}
        </Button>
      </div>
    );
  }
  return null;
};

MoveAddressTile.propTypes = {
  customerInfo: PropTypes.object.isRequired
};

export default MoveAddressTile;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/MoveAddressTile.js
 **/